import { render, staticRenderFns } from "./LimitLabel.vue?vue&type=template&id=04ca03ca&"
import script from "./LimitLabel.vue?vue&type=script&lang=js&"
export * from "./LimitLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports